// This file contains the types for the API errors

export type APIError = {
    code: number
    message: string
}

export const getErrorMessage = (code: number) => {
    switch (code) {
        case 400:
            return "Bad Request"
        case 401:
            return "Unauthorized"
        case 403:
            return "Forbidden"
        case 404:
            return "Not Found"
        case 500:
            return "Internal Server Error"
        default:
            return "Unknown Error"
    }
}
